import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';

interface CreateSessionRequest {
  user_id: string;
  tenant_id: string;
}

const createSession = async (data: CreateSessionRequest): Promise<string> => {
  const response = await axios.post('/session', data);
  return response.data;
};

export function useCreateSession() {
  const { mutate } = useMutation({
    mutationFn: createSession,
    onSuccess: (sessionId) => {
      localStorage.setItem('sessionId', sessionId);
    },
  });

  return { createSession: mutate };
}
